export default "__VITE_ASSET__DOepbYOj__"